import docx from "src/img/fileIcons/docx.png";
import jpg from "src/img/fileIcons/jpg.png";
import mp3 from "src/img/fileIcons/mp3.png";
import mp4 from "src/img/fileIcons/mp4.png";
import one from "src/img/fileIcons/one.png";
import pdf from "src/img/fileIcons/pdf.png";
import png from "src/img/fileIcons/png.png";
import pptx from "src/img/fileIcons/pptx.png";
import pst from "src/img/fileIcons/pst.png";
import msg from "src/img/fileIcons/msg.png";
import svg from "src/img/fileIcons/svg.png";
import vsdx from "src/img/fileIcons/vsdx.png";
import xlsx from "src/img/fileIcons/xlsx.png";
import php from "src/img/fileIcons/php.png";
import ini from "src/img/fileIcons/ini.png";
import json from "src/img/fileIcons/json.png";
import txt from "src/img/fileIcons/txt.png";
import compressed from "src/img/fileIcons/compressed.png";
import unkonwnFile from "src/img/fileIcons/file.png";
import folder from "src/img/fileIcons/folder.png";
//--------------------------------------------------------------------------------------------
//fileType
export default function FileIcon({
    fileType, 
    style = {}, 
    className,
    isFolder, 
    ...rest
}:{
    fileType: string,
    style?: {[key: string]: any}, 
    className: string, 
    isFolder: boolean, 

}){
    let source;
    switch(fileType.toLowerCase()){
        //***************MICROSOFT OFFICE*****************
        case "doc":
        case "docm":
        case "docx":
        case "dot":
        case "dotm":
        case "dotx":
            source = docx;
        break;
        case "xls":
        case "xlsx":
            source = xlsx;
        break;
        case "ppt":
        case "pptm":
        case "pptx":
            source = pptx;
        break;
        case "ost":
        case "pst":
            source = pst;
        break;
        case "msg":
            source = msg;
        break;
        case "vsd":
        case "vsdx":
            source = vsdx;
        break;
        case "one":
            source = one;
        break;
        //***************IMG*****************
        case "jpg":
        case "jpeg":
            source = jpg;
        break;
        case "png":
            source = png;
        break;
        case "svg":
            source = svg;
        break;
        //***************AUDIO*****************
        case "mp3":
            source = mp3;
        break;
        //***************VIDEO*****************
        case "mp4":
            source = mp4;
        break;
        //***************PDF*****************
        case "pdf":
            source = pdf;
        break;
        //***************PHP*****************
        case "php":
            source = php;
        break;
        //***************INI*****************
        case "ini":
            source = ini;
        break;
        //***************JSON*****************
        case "json":
            source = json;
        break;
        //***************TXT*****************
        case "txt":
            source = txt;
        break;
        //***************COMPRESSED*****************
        case "zip":
        case "rar":
        case "7z":
            source = compressed;
        break;
        //***************DEFAULT*****************
        default:
            source = unkonwnFile;
    }    
    if(isFolder) source = folder;
    return <img src = {source} className = {className} style = {{width: "3.6vw", ...style}} {...rest} alt = ""/>;
}
